export class Portal {
  sectionContainerId: string;
  content: HTMLElement;
  id: string;

  constructor(props: any) {
    this.sectionContainerId = props.sectionContainerId;
    this.content = props.content;
    this.id = props.id;
  }
}

export default Portal;
